export default __webpack_public_path__ + "984a1f017cce8f24ace2b00747699c23.png";